import React from 'react';

const Sessions = () => {
  const scrollToBooking = () => {
    if (window.location.pathname === '/young-drivers') {
      document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    if (window.location.pathname !== '/') {
      window.location.href = '/#book';
      return;
    }

    document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="sessions" className="py-16 sm:py-20 bg-gradient-to-br from-white via-cyan-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img
              src="/kyle-drive-logo.png"
              alt="Kyle Drive"
              className="h-16 w-auto animate-bounce"
              style={{ animationDuration: '2s' }}
            />
            <div className="inline-block px-4 py-2 bg-gradient-to-r from-cyan-500 to-teal-500 text-white rounded-full text-sm font-semibold">
              Practical Skills Training
            </div>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[hsl(210,100%,20%)] mb-4">
            What You'll Learn
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-2xl mx-auto">
            Comprehensive driving skills in a safe, traffic-free environment
          </p>
        </div>

        {/* Skills Grid - LIGHTER OVERLAYS, MORE VIBRANT */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-12">
          {/* Traffic Lights */}
          <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-white">
            <img
              src="/clean-panels/panel-13.jpg"
              alt="Traffic light and STOP sign training"
              className="w-full h-52 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            {/* Much lighter overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-cyan-600/60 via-cyan-600/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="p-4 text-white w-full">
                <h3 className="font-bold text-lg mb-1">Traffic Lights</h3>
                <p className="text-sm">Understand signals and timing</p>
              </div>
            </div>
          </div>

          {/* Junctions */}
          <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-white">
            <img
              src="/clean-panels/panel-12.jpg"
              alt="Junction navigation training with diagram"
              className="w-full h-52 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-teal-600/60 via-teal-600/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="p-4 text-white w-full">
                <h3 className="font-bold text-lg mb-1">Junctions</h3>
                <p className="text-sm">Look, assess, decide, go</p>
              </div>
            </div>
          </div>

          {/* Roundabouts - Pedestrian crossing with road markings */}
          <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-white">
            <img
              src="/clean-panels/panel-23.jpg"
              alt="Road markings and junction navigation training"
              className="w-full h-52 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-600/60 via-blue-600/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="p-4 text-white w-full">
                <h3 className="font-bold text-lg mb-1">Roundabouts</h3>
                <p className="text-sm">Approach, choose lane, flow</p>
              </div>
            </div>
          </div>

          {/* Parking */}
          <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-white">
            <img
              src="/clean-panels/panel-07.jpg"
              alt="Parking practice with cones and Kyle Drive vehicle"
              className="w-full h-52 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-purple-600/60 via-purple-600/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="p-4 text-white w-full">
                <h3 className="font-bold text-lg mb-1">Parking</h3>
                <p className="text-sm">Forward, reverse, bay parking</p>
              </div>
            </div>
          </div>

          {/* Vehicle Controls */}
          <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-white">
            <img
              src="/clean-panels/panel-06.jpg"
              alt="Learning vehicle controls at the wheel"
              className="w-full h-52 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-pink-600/60 via-pink-600/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="p-4 text-white w-full">
                <h3 className="font-bold text-lg mb-1">Vehicle Controls</h3>
                <p className="text-sm">Steering, pedals, mirrors, signals</p>
              </div>
            </div>
          </div>

          {/* Hazard Awareness */}
          <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-white">
            <img
              src="/clean-panels/panel-20.jpg"
              alt="Hazard awareness training and review"
              className="w-full h-52 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-orange-600/60 via-orange-600/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="p-4 text-white w-full">
                <h3 className="font-bold text-lg mb-1">Hazard Awareness</h3>
                <p className="text-sm">Spot risks, stay alert, stay safe</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={scrollToBooking}
            className="px-10 py-5 bg-gradient-to-r from-cyan-500 to-teal-500 text-white rounded-xl font-bold text-xl shadow-2xl hover:shadow-cyan-500/50 hover:scale-105 transition-all duration-300"
          >
            Book a Session
          </button>
        </div>
      </div>
    </section>
  );
};

export default Sessions;
